import request from "utils/request";

export async function addLinkSet(payload) {
	return request("/rest/url_list", {
		method: "PUT",
		body: payload
	});
}

export async function renameLinkSet(payload) {
	return request("/rest/url_list/" + payload.id, {
		method: "POST",
		body: payload
	});
}

export async function deleteLinkSets(payload) {
	return request("/rest/url_list/" + payload.campaignId, {
		method: "DELETE",
		body: payload.ids
	});
}

export async function getLinks(urlListId) {
	return request("/rest/url_items/" + urlListId);
}

export async function addLinks(urlListId, payload) {
	return request("/rest/url_items/" + urlListId, {
		method: "PUT",
		body: payload
	})
}

export async function saveLink(urlListId, payload) {
	return request("/rest/url_item/" + urlListId, {
		method: "POST",
		body: payload
	})
}

export async function saveLinkSetKeywords(urlListId, payload) {
	return request("/rest/url_list_keyword/" + urlListId, {
		method: "POST",
		body: payload
	})
}

export async function deleteLinks(urlListId, linkIds) {
	return request("/rest/url_items/" + urlListId, {
		method: "DELETE",
		body: linkIds
	})
}